import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fitscovery-ui-default-skeleton-loader',
  templateUrl: './ui-default-skeleton-loader.component.html',
  styleUrls: ['./ui-default-skeleton-loader.component.scss']
})
export class UiDefaultSkeletonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
